import { CustomTheme, Theme } from '@ibe/components';
import { useTheme as useLibTheme } from '@emotion/react';

export const useTheme = (): CustomTheme => {
  return useLibTheme() as Theme;
};
